globalThis.jotaiAtomCache = globalThis.jotaiAtomCache || {
  cache: new Map(),
  get: function get(name, inst) {
    if (this.cache.has(name)) {
      return this.cache.get(name);
    }

    this.cache.set(name, inst);
    return inst;
  }
};
import _styled from "styled-components";
import { useMemo } from 'react';
import { Rating as FlowRiteRating } from 'flowbite-react';
import { ratingNumberRange, getRange } from '@restworld/utils-common';
import { jsx as _jsx } from "react/jsx-runtime";
var FlowRiteRatingStar = FlowRiteRating.Star;
export function Rating(_ref) {
  var _ref$rating = _ref.rating,
      rating = _ref$rating === void 0 ? 0 : _ref$rating,
      size = _ref.size;
  var reviewRatingRange = getRange(Number(rating.toFixed()));
  var ratingStarEl = useMemo(function () {
    return ratingNumberRange.map(function (v) {
      return /*#__PURE__*/_jsx(StyledFlowRiteRatingStar, {
        filled: reviewRatingRange.includes(v)
      }, v);
    });
  }, [reviewRatingRange]);
  return /*#__PURE__*/_jsx(StyledFlowRiteRating, {
    size: size,
    children: ratingStarEl
  });
}
export default Rating;

var StyledFlowRiteRating = /*#__PURE__*/_styled(FlowRiteRating).withConfig({
  displayName: "rating__StyledFlowRiteRating",
  componentId: "sc-smge16-0"
})({});

var StyledFlowRiteRatingStar = /*#__PURE__*/_styled(FlowRiteRatingStar).withConfig({
  displayName: "rating__StyledFlowRiteRatingStar",
  componentId: "sc-smge16-1"
})(["", ""], function (_ref2) {
  var filled = _ref2.filled;
  return filled ? {
    "--tw-text-opacity": "1",
    "color": "rgb(250 202 21 / var(--tw-text-opacity))"
  } : '';
});